import eventLib from './index';

/* 监听路由跳转 */
export function onNavigate(callback) {
  eventLib.on('navigate', callback);
}

/* 监听下载引导行为 */
export function onDownloadRemind(callback) {
  eventLib.on('remind', callback);
}
